import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const CityVariantOutlineIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' {...props} ref={ref}>
        <path
            d='M12.5 19.17h-1.67V17.5h1.67v1.67Zm3.33-1.67h-1.66v1.67h1.66V17.5Zm-3.33-3.33h-1.67v1.66h1.67v-1.66ZM5.83 17.5H4.17v1.67h1.66V17.5Zm0-3.33H4.17v1.66h1.66v-1.66Zm10 0h-1.66v1.66h1.66v-1.66Zm-3.33-3.34h-1.67v1.67h1.67v-1.67Zm3.33 0h-1.66v1.67h1.66v-1.67ZM17.5 7.5a1.67 1.67 0 0 1 1.67 1.67v10H17.5v-10H9.17v10H7.5V12.5h-5v6.67H.83V12.5a1.67 1.67 0 0 1 1.67-1.67h5V9.17A1.67 1.67 0 0 1 9.17 7.5V5.83a1.67 1.67 0 0 1 1.66-1.66h1.67V.83h1.67v3.34h1.66a1.67 1.67 0 0 1 1.67 1.66V7.5Zm-1.67 0V5.83h-5V7.5h5Z'
            fill='currentColor'
        />
    </svg>
));
